import { gql } from '../../__generated__'

export const GET_USER_LANGUAGE = gql(/* GraphQL */ `
  query GetUserLanguage {
    users {
      id
      language
    }
  }
`)

export const UPDATE_USER_LANGUAGE = gql(/* GraphQL */ `
  mutation UpdateUserLanguage($where: UserWhereUniqueInput!, $data: UserUpdateInput!) {
    updateUser(where: $where, data: $data) {
      id
      language
    }
  }
`)
